/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FilledArrowRightFadedIcon = createIcon("FilledArrowRightFadedIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#767676';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "6",
    height: "10",
    viewBox: "0 0 6 10",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 10V0l5 5-5 5Z",
    fill: _color
  }));
}, {
  "replaceColor": true
});